import { makeStyles, useTheme } from "@material-ui/core/styles"
import React, { useContext } from "react"
import { Container } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import SwipeableViews from "react-swipeable-views"
import { autoPlay } from "react-swipeable-views-utils"
import SiteContext from "../../contexts/SiteContext"

import "./styles.css"
const AutoPlaySwipeableViews = autoPlay(SwipeableViews)

const useStyles = makeStyles(theme => ({
    root: {
        maxWidth: 400,
        flexGrow: 1,
    },
    header: {
        display: "flex",
        alignItems: "center",
        height: 50,
        paddingLeft: theme.spacing(4),
        backgroundColor: theme.palette.background.default,
    },
    img: {
        height: "100%",
        display: "block",
        overflow: "hidden",
        width: "100%",
    },
}))

export default function Cardapio(props) {
    const {
        aplicativoDados,
        setAplicativoDados,

        estabelecimentoAtual,
        setEstabelecimentoAtual,

        setCarrinho,
        carrinho,

        cardapio,
        setCardapio,

        enderecoAtual,
    } = useContext(SiteContext)

    const usuarioPedidoMesa = JSON.parse(localStorage.getItem("usuarioPedidoMesaCF"))

    const history = useHistory()

    const allBanners = () => {
        let listaBanners = estabelecimentoAtual?.bannersEstabelecimento
        var array = []

        for (let indexBanner = 0; indexBanner < listaBanners?.length; indexBanner++) {
            let banner = listaBanners[indexBanner]
            if (banner.exibirCardapio) {
                array.push({
                    url: banner.urlBanner,
                })
            }
        }

        return array
    }

    const [bannersStep, setBannersStep] = React.useState(allBanners())

    const classes = useStyles()
    const theme = useTheme()
    const [activeStep, setActiveStep] = React.useState(0)

    return (
        <Container className="containerEstabelecimentoComponente">
            <div className="EstabelecimentoComponente row">
                <div
                    className={"divFundo " + (bannersStep?.length > 0 ? "" : " notBannerSlide")}
                    style={{ background: `${aplicativoDados?.corSiteSecundaria}` }}
                >
                    {bannersStep?.length > 0 ? (
                        <AutoPlaySwipeableViews
                            style={{ height: "100%", overflow: "hidden" }}
                            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                            index={activeStep}
                            onChangeIndex={step => {
                                setActiveStep(step)
                            }}
                            enableMouseEvents
                        >
                            {bannersStep.map((banner, index) => (
                                <div key={index}>
                                    {Math.abs(activeStep - index) <= 2 ? (
                                        <img
                                            alt={"banner estabelecimento"}
                                            className={classes.img}
                                            src={banner.url}
                                        />
                                    ) : null}
                                </div>
                            ))}
                        </AutoPlaySwipeableViews>
                    ) : null}
                </div>
            </div>
        </Container>
    )
}
